import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

class ExternalMessageSendingStatus {
    public static get failed(): FlatLookupView { return ExternalMessageSendingStatus.getStatusByCode("EXTERNALCOMMUNICATION_SENDSTATUS_FAILED"); }
    public static get sent(): FlatLookupView { return ExternalMessageSendingStatus.getStatusByCode("EXTERNALCOMMUNICATION_SENDSTATUS_SENT"); }
    public static get sending(): FlatLookupView { return ExternalMessageSendingStatus.getStatusByCode("EXTERNALCOMMUNICATION_SENDSTATUS_SENDING"); }

    public static getAll(): FlatLookupView[] {
        let allInterpretations = cacheStore.FindLookupsByTypeCode("ExternalCommunicationSendStatus");
        return allInterpretations != null ? allInterpretations.sortByProperty(p => p.LookupPosition) : [];
    }

    public static getStatusByCode(code: string): FlatLookupView {
        return ExternalMessageSendingStatus.getAll().filter(l => l.LookupCode === code).firstOrDefault();
    }
}

export { ExternalMessageSendingStatus };
